import { observer } from "mobx-react";
import { DriveSomewhereElseToggleProps } from "components/flexComponents/WizardPackagePWA/typings";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-checkbox";
import * as React from "react";
import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const DriveSomewhereElseToggle = observer((props: DriveSomewhereElseToggleProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox
          id="drive-somewhere-else-toggle"
          onChange={props.toggleDriveSomewhereElse}
          checked={props.packageWizardState.driveSomewhereElse}
        >
          {formatText(locKeys.carDifferentPickOffDropOffLabel)}
        </UitkCheckbox>
        <input
          type="hidden"
          name="isDriveSomewhereElse"
          value={props.packageWizardState.driveSomewhereElse ? 1 : 0}
          data-testid="drive-somewhere-else-input"
        />
      </div>
    </UitkLayoutGridItem>
  );
});
